import { UntypedFormGroup } from '@angular/forms';

import { SnFormFieldConfig } from '../types/form-field-config.type';
import { SnFormOptions } from '../types/form-options.type';

export interface ISnHasForm<Model = Object> {
  readonly form: UntypedFormGroup;
  readonly formFields: SnFormFieldConfig[];
  readonly formOptions?: SnFormOptions;
  formModel: Model;

  submitForm(): void;
  resetForm?(): void;
}
